export default __webpack_public_path__ + "static/media/thanos_snap_sound.f2cd6c4c.mp3";